import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleNavClick = (hash) => {
    if (isHomePage) {
      // Si estamos en la página principal, solo hacer scroll
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Si no estamos en la página principal, navegar a la página principal y luego hacer scroll
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };


  return (
    <header className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <a className="navbar-brand d-flex align-items-center" href={isHomePage ? "#inicio" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#inicio'); }}>
          <img 
            src={`${process.env.PUBLIC_URL || ''}/images/logofooter.png`}
            alt="Tránsito & Derecho" 
            style={{ height: '50px', width: 'auto' }}
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item">
              <a className="nav-link" href={isHomePage ? "#inicio" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#inicio'); }}>Inicio</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={isHomePage ? "#como-funciona" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#como-funciona'); }}>Cómo Funciona</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={isHomePage ? "#nosotros" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#nosotros'); }}>Nosotros</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={isHomePage ? "#tips" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#tips'); }}>Antecedentes</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={isHomePage ? "#contacto" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#contacto'); }}>Contacto</a>
            </li>
            <li className="nav-item ms-2">
              <a className="btn btn-outline-primary btn-sm" href={isHomePage ? "#acceso" : "/"} onClick={(e) => { e.preventDefault(); handleNavClick('#acceso'); }} style={{ whiteSpace: 'nowrap' }}>
                Si sos partner o cliente
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;

